import { apiClient } from '@/libs/axios';
import {
  toSignoutDTO,
  type SignoutDTO,
  type SignoutPayload,
} from '../schemas/sign-out.schema';
import type { MutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const signOut = async (data: SignoutPayload): Promise<SignoutDTO> => {
  const url = '/auth/logout';
  const response = await apiClient.post(url, data);

  return toSignoutDTO(response);
};

export const signOutMutationOptions = (): MutationOptions<
  SignoutDTO,
  AxiosError,
  SignoutPayload
> => ({
  mutationFn: signOut,
});
